import { drivelabels_v2 } from '@googleapis/drivelabels';
import { bulkEnableDriveLabels } from '../../../api/drive-labels-api';
import { Messages } from '../../../utils/message-constants';
import { DriveRoles } from '../../../utils/roles/client-roles';
import LabelActionDialog from './label-action-dialog';

type Label = drivelabels_v2.Schema$GoogleAppsDriveLabelsV2Label;

interface EnableLabelsDialogProps {
  open: boolean;
  handleClose: () => void;
  labels: Label[];
  changeLogRoles: string[];
  onEnabled: () => void;
}

export default function EnableLabelsDialog({
  open,
  handleClose,
  labels,
  changeLogRoles,
  onEnabled,
}: EnableLabelsDialogProps) {
  const count = labels.length;
  const name = labels[0]?.properties?.title;

  return (
    <LabelActionDialog
      open={open}
      handleClose={handleClose}
      labels={labels}
      changeLogRoles={changeLogRoles}
      changeLogRole={DriveRoles.UpdateDriveLabelsStatus.value}
      title={Messages.DriveLabels.EnableTitle(count)}
      body={
        count > 1 ? (
          Messages.DriveLabels.EnableBodyMany
        ) : (
          <>
            {Messages.DriveLabels.EnableBodyBefore}{' '}
            {name ? <strong>{name}</strong> : 'this label'}{' '}
            {Messages.DriveLabels.EnableBodyAfter}
          </>
        )
      }
      confirmLabel="Enable"
      run={bulkEnableDriveLabels}
      successMessage={Messages.DriveLabels.EnableSuccess(count)}
      partialMessage={Messages.DriveLabels.EnablePartial}
      errorMessage={Messages.Errors.Network.Updating(
        count === 1 ? 'the label' : 'the labels'
      )}
      onDone={onEnabled}
    />
  );
}
